import { render, staticRenderFns } from "./default-footer.vue?vue&type=template&id=77849c24&scoped=true&"
import script from "./default-footer.vue?vue&type=script&lang=js&"
export * from "./default-footer.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=77849c24&scoped=true&lang=css&"
import style1 from "./default-footer.vue?vue&type=style&index=1&id=77849c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77849c24",
  null
  
)

export default component.exports